<template>
  <div>
    <div id="mapDiv"></div>
    <div class="tk_box">
      <img src="../assets/img/jt01.png" alt="" style="position: absolute;right: 10px;top: 6px;cursor: pointer;"
        @click="showImg" v-if="this.str == 1">
      <img src="../assets/img/jt02.png" alt="" style="position: absolute;right: 10px;top: 6px;cursor: pointer;"
        @click="showImg" v-if="this.str == 0">
      <div class="myscroll1 kgo-scroll-sty" style="height: 100%;">
        <ul class="kgo-croll-body">
          <li v-for="item in dataAlarmList" v-if="item.type == 2">
            <i style="background: #FF3F35;"></i>
            <span style="width: 120px;display: inline-block;color: #FF3F35;font-weight: bold;">超标</span>
            <span style="font-weight: bold;">{{item.deviceName}}</span>
            <span style="float: right;padding-right: 70px;">{{item.createTime.substr(0,10)}}</span>
          </li>
          <li v-for="item in dataAlarmList" v-if="item.type == 4">
            <i style="background: #ffe029;"></i>
            <span style="width: 120px;display: inline-block;color: #ffe029;">故障</span>
            <span>{{item.deviceName}}</span>
            <span style="float: right;padding-right: 70px;">{{item.createTime.substr(0,10)}}</span>
          </li>
          <li v-for="item in dataAlarmList" v-if="item.type == 3">
            <i style="background: #c3c3c3;"></i>
            <span style="width: 120px;display: inline-block;color: #c3c3c3;">缺失</span>
            <span>{{item.deviceName}}</span>
            <span style="float: right;padding-right: 70px;">{{item.createTime.substr(0,10)}}</span>
          </li>
          <li v-for="item in dataWorkList">
            <img src="../assets/img/gj.png" alt="" width="28" height="28">
            <span style="width: 120px;display: inline-block;">{{item.statusName}}</span>
            <span>{{item.content+' ('+item.title+')'}}</span>
            <span style="float: right;padding-right: 70px;">{{item.createTime.substr(0,10)}}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="gx_box" id="gx_box" v-if="this.datauserLogList.length != 0">
      <i @click="gx_box">X</i>
      <p style="font-size: 18px;font-weight: bold;height: 50px;line-height: 50px;">
        {{'V'+datauserLogList.version+'版本更新日志'}}</p>
      <ul style="height: 300px;text-align: left;padding-left: 20px;background: #eee;margin-bottom: 20px;">
        <li style="white-space: pre-wrap;">{{datauserLogList.content}}</li>
      </ul>
      <div style="margin-top: 10px;">
        <router-link :to="{path:'/indexhome/updateLog',query:{id:datauserLogList.id}}" replace>
          <span style="float: left;color: #1FA6FC;cursor: pointer;">查看详情</span>
        </router-link>
        <!--        <span style="margin-left: 50px;">{{times+'s'}}</span>-->
        <el-checkbox-group v-model="form.type" @change="handleCheckedCitiesChange" style="float:right;">
          <el-checkbox label="不再弹出该提示"></el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <div class="input-card hide" id="div_chart" v-show="isShow">
      <!-- 单独设备显示电量 -->
      <img src="../assets/img/battery.png" alt="" width="28" height="26" style="position: absolute;right: 6px;top: 36px;width: 54px;height: 44px;"
      v-if="isShowPcIcon == true">


      <img src="../assets/img/worldwide.png" alt="" width="28" height="26" style="position: absolute;right: 34px;cursor: pointer;"
        id="toCenter">
      <router-link :to="{path:'/indexhome/deviceDetailRecordView', query:{id: deviceInfo.id} }">
        <img src="../assets/img/icons8sb1.png" alt="" width="28" height="28" style="position: absolute;right: 4px;">
      </router-link>
      <label id="labelbt">
        <span id="info_company_name" class="blod"></span>在
        <span id="info_poi_name" class="blod"></span>设置的
        <span id="info_poi_device_count" class="blod"></span>台设备：
      </label>
      <div class="input-item" :style="isShowPcIcon == true ? 'display:initial;overflow-x: scroll;height: 40px;overflow-y: hidden;width: 87%;' :'display:initial;overflow-x: scroll;height: 44px;overflow-y: hidden;'">
        <div id="div_gis_device_list" style="width: max-content;">
          <input type="text" @click="gisEcharts(d.deviceId)" v-for="d in dataList.gisDevices" :title="d.uniqueCode"
            :value="d.deviceName" class="btn blue">
        </div>
      </div>
      <span style="position: absolute;top: 50%;left: 50%;margin-left: -75px;">{{listsp}}</span>
      <div style="height: calc(100% - 100px);margin-top: 10px;" id="yhecharts"></div>
    </div>
  </div>
</template>



<script>
import $ from "jquery";
var map,
  marker_list = {},
  myChart;
var _that = this;
import "../assets/scroll.js";
export default {
  name: "mapview",
  data() {
    return {
      isShowPcIcon: "",
      form: {
        type: ""
      },
      times: "5",
      listsp: "",
      poiId: "",
      dataList: [],
      dataAlarmList: [],
      dataWorkList: [],
      datauserLogList: {
        contentList: [],
        version: "",
        recordDate: ""
      },
      deviceInfo: {},
      companyName: "",
      isShow: false,
      eightaveraged: {
        legend: [],
        series: [
          {
            name: "",
            type: "line",
            stack: "总量",
            data: []
          }
        ],
        xaxisData: []
      },
      str: 1
    };
  },
  created() {
    this.getAlarmwork();
  },
  mounted() {
    if (location.href.indexOf("#caseDsc") == -1) {
      location.href = location.href + "#caseDsc";
      window.location.reload();
    }
    setTimeout(index => {
      this.getMapp();
      $(".myscroll1").beginScroll({
        speed: 30, //数值越大，速度越慢
        rowHeight: 44 //li的高度
      });
    }, 500);
    let user = JSON.parse(sessionStorage.getItem("user") || "[]");
    this.groupList = JSON.parse(sessionStorage.getItem("menu") || "[]").childs;
    this.title = JSON.parse(sessionStorage.getItem("title") || "[]");
    this.userName = user.username;
    if (!user.mobile) {
      this.$notify({
        type: "warning",
        title: "提示",
        message: "当前账户暂未绑定手机号！",
        position: "top-right",
        offset: 150
      });
    }
  },
  methods: {
    getMapp() {
      this.$http({
        url: this.$http.adornUrl("poi/gisPoi/list"),
        method: "get"
      }).then(({ data }) => {
        let datanum = data.data.gis.data;
        // var T = window.T;
        _that.map = new T.Map("mapDiv");
        // map = new T.Map("mapDiv")
        //设置显示地图的中心点和级别
        _that.map.centerAndZoom(new T.LngLat(105.953743, 28.50441), 5);
        //允许鼠标双击放大地图
        _that.map.enableScrollWheelZoom();
        // 控制组件
        _that.map.addControl(new T.Control.MapType());
        // 切换到“卫星混合”视图
        _that.map.setMapType(TMAP_HYBRID_MAP);
        //每个标记信息
        if (datanum != null && datanum.length > 0) {
          for (let i in datanum) {
            this.addMarkered(datanum[i], i);
          }
        } else {
          alert(
            "您当前账户下，无有效的企业或有效的点位（POI）！\n请确保企业状态为有效；请确保点位的状态为有效。"
          );
        }
        //设置地图的显示级别
        _that.map.setMinZoom(4);
        _that.map.setMaxZoom(18);
        //设置地图的显示范围
        _that.map.setMaxBounds(
          new T.LngLatBounds(
            new T.LngLat(162.146631, 60.244675),
            new T.LngLat(47.800928, -2.274759)
          )
        );
        //禁止鼠标地图惯性拖拽
        _that.map.disableInertia();
      });
    },
    addMarkered(data, i) {
      let _this = this;
      let marker, imagd;
      if (data.status == "1") {
        imagd = "./../../static/img/map/lcon02.png"; //正常
      } else if (data.status == "2") {
        imagd = "./../../static/img/map/lcon01.png"; //超标
      } else if (data.status == "3") {
        imagd = "./../../static/img/map/lcon04.png"; //缺失
      } else if (data.status == "4") {
        imagd = "./../../static/img/map/lcon03.png"; //故障
      }
      let icon = new T.Icon({
        iconUrl: imagd
      });
      var point = new T.LngLat(data.longitude, data.latitude);
      marker = new T.Marker(point, { icon: icon }); // 创建标注
      _that.map.addOverLay(marker);
      $(".tdt-interactive").css("height", "30px");
      var markerInfoWin = new T.InfoWindow(
        "<div>" + data.poiName + "（" + data.deviceCount + " 台）</div>"
      );
      marker.addEventListener("click", function() {
        marker.openInfoWindow(markerInfoWin);
        this.poiId = data.poiId;
        $("#info_company_name").html(data.companyName);
        $("#info_poi_name").html(data.poiName);
        $("#info_poi_device_count").html(data.deviceCount);
        $("#labelbt").attr(
          "title",
          data.companyName + data.poiName + data.deviceCount
        );
        _this.getDataList(this.poiId, data);
      });
      // 将标注添加到地图中
      marker_list[i] = marker;
    },
    getDataList(poiId, data) {
      $("#toCenter").click(function() {
        // 传入经纬度，设置地图中心点
        var position = new T.LngLat(data.longitude, data.latitude); // 标准写法
        _that.map.centerAndZoom(position);
      });
      this.$http({
        url: this.$http.adornUrl("device/gisDevice/list"),
        method: "get",
        params: this.$http.adornParams({
          poiId: poiId
        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.dataList = data.data;
          this.deviceInfo = {
            id: data.data.gisDevices[0].deviceId,
            name: data.data.gisDevices[0].deviceName
          };
          this.isShowPcIcon = data.data.gisDevices[0].isShowPcIcon;
          this.isShow = true;
          this.gisEcharts(this.deviceInfo.id);
        }
      });
    },
    gisEcharts(deviceId) {
      if (myChart) {
        myChart.clear();
      }
      this.$http({
        // url: this.$http.adornUrl('/device/gisDeviceRecord/' + deviceId),
        url: this.$http.adornUrl("bigScreen/deviceRealTimeData/" + deviceId),
        method: "get"
      }).then(({ data }) => {
        this.listsp = "";
        this.eightaveraged = data.data.deviceEcharts;
        if (this.eightaveraged.series == null) {
          this.listsp = data.msg;
        } else {
          myChart = this.$echarts.init(document.getElementById("yhecharts"));
          // 绘制图表
          myChart.setOption({
            tooltip: {
              trigger: "axis",
              axisPointer: {
                lineStyle: {
                  color: "#57617B"
                }
              }
            },
            legend: {
              type: "scroll",
              icon: "circle",
              itemWidth: 10,
              itemHeight: 10,
              itemGap: 10,
              data: this.eightaveraged.legend,
              right: "16",
              left: "10",
              textStyle: {
                color: "#000",
                fontSize: 14
              }
            },
            grid: {
              containLabel: true,
              left: "4%",
              right: "4%",
              top: 50,
              bottom: "4%"
            },
            xAxis: {
              type: "category",
              data: this.eightaveraged.xaxis,
              axisLine: {
                //  改变x轴颜色
                show: false,
                lineStyle: {
                  color: "#26D9FF"
                }
              },
              axisLabel: {
                //  改变x轴字体颜色和大小
                textStyle: {
                  color: "000",
                  fontSize: 14
                }
              },
              axisTick: {
                show: false
              },
              splitLine: {
                show: false
              }
            },
            yAxis: {
              type: "value",
              // name: "(浓度值)",
              axisLine: {
                //  改变y轴颜色
                show: false,
                lineStyle: {
                  color: "#000"
                }
              },
              axisLabel: {
                //  改变y轴字体颜色和大小
                //formatter: '{value} m³ ', //  给y轴添加单位
                textStyle: {
                  color: "#000",
                  fontSize: 14
                }
              },
              axisTick: {
                show: false
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: ["#314a63"]
                }
              }
            },
            series: this.eightaveraged.series
          });
          window.addEventListener("resize", function() {
            myChart.resize();
          });
        }
      });
    },
    showImg() {
      if (this.str == 1) {
        $(".tk_box").css("height", "226px");
        $(".tk_box .myscroll1").css("overflow-y", "scroll");
        this.str = 0;
        return;
      }
      if (this.str == 0) {
        $(".tk_box").css("height", "44px");
        $(".tk_box .myscroll1").css("overflow-y", "inherit");
        this.str = 1;
        return;
      }
    },
    handleCheckedCitiesChange(value) {
      if (value == false) {
        value = 1;
      } else if (value == true) {
        value = 0;
      }
      this.$http({
        url: this.$http.adornUrl("/versionsLog/update/" + value),
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 200) {
          var div = $("#gx_box");
          div.css("display", "none");
        }
      });
    },
    getAlarmwork() {
      this.datauserLogList = [];
      this.$http({
        url: this.$http.adornUrl("/bigScreen/getDeviceAlarm"),
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.dataAlarmList = data.data.alarm;
          this.dataWorkList = data.data.work;
        }
      });
      this.$http({
        url: this.$http.adornUrl("/versionsLog/userLog"),
        method: "get"
      }).then(({ data }) => {
        if (data && data.msg == "当前用户已关闭日志推送") {
          var div = $("#gx_box");
          div.css("display", "none");
        }
        if (data.data == null) {
          this.datauserLogList = [];
        } else if (data && data.code === 200) {
          this.datauserLogList = data.data.userLog;
        }
      });
    },
    gx_box() {
      var div = $("#gx_box");
      div.css("display", "none");
    }
  }
};
</script>
 
<style scoped>
#mapDiv {
  height: 100vh;
  width: 100%;
}
::-webkit-scrollbar-track {
  /* background-color: #ffffff; */
}

.input-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  width: 22rem;
  border-width: 0;
  border-radius: 0.4rem;
  position: fixed;
  bottom: 1rem;
  right: 10px;
  flex: 1 1 auto;
  width: 25rem !important;
  height: 50%;
  z-index: 999;
  padding: 14px;
}

.input-card .btn {
  margin-right: 0.8rem;
}

.blue {
  background-color: #25a5f7;
  color: white;
}

.input-card label {
  width: calc(100% - 70px);
  height: 32px;
  font-size: 14px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: bold;
  color: #333;
}

.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border: 1px solid transparent;
  background-color: transparent;
  background-image: none;
  color: #25a5f7;
  border-color: #25a5f7;
  line-height: 1.5;
  border-radius: 1rem;
  -webkit-appearance: button;
  cursor: pointer;
}

.btn {
  float: left;
  height: 26px;
  padding: 0 0px;
  width: auto;
  font-size: 12px;
}

.tk_box::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0.6) !important;
}

.tk_box {
  position: absolute;
  top: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.6);
  width: 670px;
  height: 44px;
  line-height: 44px;
  /*border: 1px solid #101010;*/
  left: 50%;
  border-radius: 13px;
  margin-left: -335px;
  color: #fff;
  font-size: 24px;
  overflow: hidden;
}

.tk_box li {
  text-align: left;
  padding-left: 10px;
  font-size: 20px;
  /*font-weight: bold;*/
}

.tk_box li i {
  display: inline-block;
  width: 22px;
  height: 22px;
  border-radius: 10px;
  vertical-align: middle;
  margin-right: 5px;
  margin-top: -6px;
}

.gx_box {
  position: absolute;
  top: 0;
  width: 600px;
  height: 390px;
  background: #fff;
  z-index: 9999;
  left: 45%;
  margin-left: -250px;
  top: 50%;
  margin-top: -260px;
  padding: 10px 20px;
  border-radius: 10px;
}

/deep/ .gx_box .el-checkbox__label {
  padding-left: 4px;
}

.gx_box i {
  position: absolute;
  top: 8px;
  font-style: initial;
  right: 20px;
  font-size: 24px;
  z-index: 999;
  cursor: pointer;
}

.gx_box ul {
  overflow-y: scroll;
}

.gx_box ul li {
  line-height: 26px;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/mapview.vue